import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'
import LoginComponent from './LoginComponent'
import RegisterComponent from './RegisterComponent'
import ResetPassword from './ResetPassword'

export const AUTH_MODES = Object.freeze({ LOGIN: 'login', SIGNUP: 'signup', RESET: 'reset' })

export const ACCOUNT_EXISTS_NOTICE = 'You already have an account. Please log in to continue.'

/**
 * Picks which unauthenticated form to show. `prefilledEmail` (from the
 * ?email= query param) is passed to the login and signup forms, which render
 * it as a locked email field.
 *
 * `nextPath` (an allowed ?next= destination, see entryParams) puts the signup
 * form in its entry-link mode: no membership picker or payment, the new
 * account is linked to the member's existing record, then `onAuthenticated`
 * continues to nextPath. If the signup form finds the email already has an
 * account, this shows the prefilled login form instead of an error.
 */
const AuthEntry = ({
    mode,
    prefilledEmail,
    loginFn,
    resetFn,
    createNewAcctFn,
    resetToLogin,
    resetPwdFn,
    backToLoginFn,
    nextPath,
    onAuthenticated,
    linkExpired
}) => {
    const [accountExists, setAccountExists] = useState(false)

    const login = (notice) => (
        <div>
            {notice && <Typography variant="body1" role="status" style={{ textAlign: 'center', marginTop: 16 }}>{notice}</Typography>}
            <LoginComponent
                loginFn={loginFn}
                resetFn={resetFn}
                createNewAcctFn={createNewAcctFn}
                prefilledEmail={prefilledEmail}
            />
        </div>
    )

    switch (mode) {
        case AUTH_MODES.RESET:
            return <ResetPassword resetPwdFn={resetPwdFn} backToLoginFn={backToLoginFn} />
        case AUTH_MODES.SIGNUP:
            if (accountExists) {
                return login(ACCOUNT_EXISTS_NOTICE)
            }
            return (
                <RegisterComponent
                    resetFn={resetToLogin}
                    prefilledEmail={prefilledEmail}
                    nextPath={nextPath}
                    onAuthenticated={onAuthenticated}
                    onAccountExists={() => setAccountExists(true)}
                />
            )
        default:
            return login(linkExpired
                ? `This sign-in link has expired or was replaced by a newer email. Log in to continue${nextPath ? ' to your renewal' : ''}.`
                : undefined)
    }
}

export default AuthEntry
